'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/function-bind/index.js
// module id = 217
// module chunks = 168707334958949